import React from "react";
import { Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

export const HelpManagedResourceType = () => {
  return (
    <>
      <Title level={5}>
        <QuestionCircleOutlined />
        &nbsp;Creating Managed Resource Types
      </Title>
      <ul>
        <li>
          <Text>Manage Resource URL template:</Text> URL to your site where
          users can manage Resources (URL/resourcename).
        </li>
        <li>
          <Text>Create Resource URL:</Text> URL to your sire where users can
          create Resources.
        </li>
      </ul>
    </>
  );
};
